// export default (value: any) => typeof value !== "boolean" && value !== null && value !== undefined && (Object.keys(value).length > 0 || value.length > 0 || value > 0);

export default (value: unknown) => {
    return (value !== undefined)
}